import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  StopTwoTone,
} from "@ant-design/icons";

export const Checkmark = ({ className }: { className?: string }) => (
  <CheckCircleTwoTone twoToneColor="#52c41a" className={className} />
);
export const X = ({ className }: { className?: string }) => (
  <CloseCircleTwoTone twoToneColor="#ff4d4f" className={className} />
);
export const Terminated = ({ className }: { className?: string }) => (
  <StopTwoTone twoToneColor="#ff4d4f" className={className} />
);
